/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OriginalPremiumScheduleResponseDto
 */
export interface OriginalPremiumScheduleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    documentNo: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    insured: string;
    /**
     * 
     * @type {Date}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    ppwDueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    premiumStatus: OriginalPremiumScheduleResponseDtoPremiumStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    gstOnPremium: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    cedingCommission: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    gstOnCedingCommission: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    sourceBrokerage: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    ere: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    gstOnEre: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    otherDeductions: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    withholdingTax: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    netPremiumDueFromBroker: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    pinnacleCommission: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    ait: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    taxesAndFees: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    binderCashRemittance: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    nocStatus: OriginalPremiumScheduleResponseDtoNocStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    premiumScheduleId: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    gstOnSourceBrokerage: string;
    /**
     * Settlement currency
     * @type {boolean}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    closing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OriginalPremiumScheduleResponseDto
     */
    closingReference?: string;
}


/**
 * @export
 */
export const OriginalPremiumScheduleResponseDtoPremiumStatusEnum = {
    Current: 'Current',
    Overdue30Days: 'overdue_30_days',
    Overdue60Days: 'overdue_60_days',
    Overdue90Days: 'overdue_90_days',
    OverdueMoreThan90Days: 'overdue_more_than_90_days',
    Paid: 'Paid'
} as const;
export type OriginalPremiumScheduleResponseDtoPremiumStatusEnum = typeof OriginalPremiumScheduleResponseDtoPremiumStatusEnum[keyof typeof OriginalPremiumScheduleResponseDtoPremiumStatusEnum];

/**
 * @export
 */
export const OriginalPremiumScheduleResponseDtoNocStatusEnum = {
    NocDue: 'NOC Due',
    NocIssued: 'NOC Issued',
    Paid: 'Paid',
    Cancelled: 'Cancelled',
    ExtensionGranted: 'Extension Granted'
} as const;
export type OriginalPremiumScheduleResponseDtoNocStatusEnum = typeof OriginalPremiumScheduleResponseDtoNocStatusEnum[keyof typeof OriginalPremiumScheduleResponseDtoNocStatusEnum];


/**
 * Check if a given object implements the OriginalPremiumScheduleResponseDto interface.
 */
export function instanceOfOriginalPremiumScheduleResponseDto(value: object): value is OriginalPremiumScheduleResponseDto {
    if (!('documentNo' in value) || value['documentNo'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('ppwDueDate' in value) || value['ppwDueDate'] === undefined) return false;
    if (!('premiumStatus' in value) || value['premiumStatus'] === undefined) return false;
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    if (!('gstOnPremium' in value) || value['gstOnPremium'] === undefined) return false;
    if (!('cedingCommission' in value) || value['cedingCommission'] === undefined) return false;
    if (!('gstOnCedingCommission' in value) || value['gstOnCedingCommission'] === undefined) return false;
    if (!('sourceBrokerage' in value) || value['sourceBrokerage'] === undefined) return false;
    if (!('ere' in value) || value['ere'] === undefined) return false;
    if (!('gstOnEre' in value) || value['gstOnEre'] === undefined) return false;
    if (!('otherDeductions' in value) || value['otherDeductions'] === undefined) return false;
    if (!('withholdingTax' in value) || value['withholdingTax'] === undefined) return false;
    if (!('netPremiumDueFromBroker' in value) || value['netPremiumDueFromBroker'] === undefined) return false;
    if (!('pinnacleCommission' in value) || value['pinnacleCommission'] === undefined) return false;
    if (!('ait' in value) || value['ait'] === undefined) return false;
    if (!('taxesAndFees' in value) || value['taxesAndFees'] === undefined) return false;
    if (!('binderCashRemittance' in value) || value['binderCashRemittance'] === undefined) return false;
    if (!('nocStatus' in value) || value['nocStatus'] === undefined) return false;
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    if (!('gstOnSourceBrokerage' in value) || value['gstOnSourceBrokerage'] === undefined) return false;
    return true;
}

export function OriginalPremiumScheduleResponseDtoFromJSON(json: any): OriginalPremiumScheduleResponseDto {
    return OriginalPremiumScheduleResponseDtoFromJSONTyped(json, false);
}

export function OriginalPremiumScheduleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OriginalPremiumScheduleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'documentNo': json['documentNo'],
        'description': json['description'],
        'insured': json['insured'],
        'ppwDueDate': (new Date(json['ppwDueDate'])),
        'premiumStatus': json['premiumStatus'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'gstOnPremium': json['gstOnPremium'],
        'cedingCommission': json['cedingCommission'],
        'gstOnCedingCommission': json['gstOnCedingCommission'],
        'sourceBrokerage': json['sourceBrokerage'],
        'ere': json['ere'],
        'gstOnEre': json['gstOnEre'],
        'otherDeductions': json['otherDeductions'],
        'withholdingTax': json['withholdingTax'],
        'netPremiumDueFromBroker': json['netPremiumDueFromBroker'],
        'pinnacleCommission': json['pinnacleCommission'],
        'ait': json['ait'],
        'taxesAndFees': json['taxesAndFees'],
        'binderCashRemittance': json['binderCashRemittance'],
        'nocStatus': json['nocStatus'],
        'premiumScheduleId': json['premiumScheduleId'],
        'gstOnSourceBrokerage': json['gstOnSourceBrokerage'],
        'closing': json['closing'] == null ? undefined : json['closing'],
        'closingReference': json['closingReference'] == null ? undefined : json['closingReference'],
    };
}

export function OriginalPremiumScheduleResponseDtoToJSON(json: any): OriginalPremiumScheduleResponseDto {
    return OriginalPremiumScheduleResponseDtoToJSONTyped(json, false);
}

export function OriginalPremiumScheduleResponseDtoToJSONTyped(value?: OriginalPremiumScheduleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentNo': value['documentNo'],
        'description': value['description'],
        'insured': value['insured'],
        'ppwDueDate': ((value['ppwDueDate']).toISOString()),
        'premiumStatus': value['premiumStatus'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'gstOnPremium': value['gstOnPremium'],
        'cedingCommission': value['cedingCommission'],
        'gstOnCedingCommission': value['gstOnCedingCommission'],
        'sourceBrokerage': value['sourceBrokerage'],
        'ere': value['ere'],
        'gstOnEre': value['gstOnEre'],
        'otherDeductions': value['otherDeductions'],
        'withholdingTax': value['withholdingTax'],
        'netPremiumDueFromBroker': value['netPremiumDueFromBroker'],
        'pinnacleCommission': value['pinnacleCommission'],
        'ait': value['ait'],
        'taxesAndFees': value['taxesAndFees'],
        'binderCashRemittance': value['binderCashRemittance'],
        'nocStatus': value['nocStatus'],
        'premiumScheduleId': value['premiumScheduleId'],
        'gstOnSourceBrokerage': value['gstOnSourceBrokerage'],
        'closing': value['closing'],
        'closingReference': value['closingReference'],
    };
}

